import {
  buildSubmitAnalyticsMetadata,
  buildOrganizationList,
} from '../utils/chooseorgUtil';

import {
  SUBMIT_CHOOSE_ORG_SUCCESS,
  SUBMIT_CHOOSE_ORG_FAILURE,
  DISPLAY_ORGANIZATIONS,
  LOADING_ORGANIZATIONS,
  ORGANIZATION_ERROR,
  NO_ORGANIZATIONS,
} from '../actions/types';

const initialState = {
  showForm: false,
  isLoading: true,
  organizationList: [],
  showError: false,
  submitSuccessful: false,
  choiceAvailable: true,
};

export default function chooseorg(state = initialState, action) {
  switch (action.type) {
    case LOADING_ORGANIZATIONS: {
      return {
        ...state,
        organizationList: [],
        showForm: false,
        isLoading: true,
        showError: false,
        selectedChoice: action.payload ? action.payload : '',
      };
    }
    case DISPLAY_ORGANIZATIONS: {
      return {
        ...state,
        showForm: true,
        isLoading: false,
        showError: false,
        ...buildOrganizationList(action.payload),
      };
    }
    case NO_ORGANIZATIONS: {
      return {
        ...state,
        organizationList: [],
        showForm: false,
        isLoading: true,
        showError: false,
        choiceAvailable: false,
      };
    }
    case ORGANIZATION_ERROR:
    case SUBMIT_CHOOSE_ORG_FAILURE: {
      return {
        ...state,
        organizationList: [],
        showForm: false,
        isLoading: false,
        showError: true,
      };
    }
    case SUBMIT_CHOOSE_ORG_SUCCESS: {
      return {
        ...state,
        organizationList: [],
        showForm: false,
        isLoading: true,
        submitSuccessful: true,
        ...buildSubmitAnalyticsMetadata(
          action.payload,
          state.defaultChoice,
          state.selectedChoice,
        ),
      };
    }
    default:
      return state;
  }
}
